export default {
  replaysSessionSampleRate: 0.5,
  tracesSampleRate: 1,
}
